import PagedSortableTable from "../table/PagedSortableTable";
import { React, useContext, useState } from "react";
// import ProductList from "./ProductList";
// import { productColumns } from "../../helpers/constants/constants";
// import ProductDialog from "./ProductDialog";
import PageTitle from "../general/PageTitle";
import DashboardLink from "../general/links/DashboardLink";
import CurrentPage from "../general/links/CurrentPage";
import ItemSearchList from "./itemSearchList";
import ItemSearchDialog from "./ItemSearchDialog";
import { itemSearchColumns } from "../../helpers/constants/constants";
import { UserContext } from "../../helpers/UserContext";
import { Button } from "@mui/material";
import * as XLSX from 'xlsx';
import axiosInstance from "../../helpers/axios";

export default function ItemSearch(){
  // Retrieve user information
  const { user } = useContext(UserContext);
  const [isExporting, setIsExporting] = useState(false);

  // Function to fetch all filtered records and generate the Excel file
  const handleExport = async () => {
    try {
      setIsExporting(true);
      // Grab current search and query parameters from the window location
      const queryParams = window.location.search;

      // Call the unpaginated export endpoint
      const response = await axiosInstance.get(`/itemsearch/export_excel/${queryParams}`);
      const data = response.data;

      // Map rows for Excel export matching your table columns
      const filterData = data.map(item => ({
        "Product Code": item.productCode,
        "Product Name": item.productName,
        "Barcode": item.barcode,
        "Units Per Inner": item.unitsPerInner,
        "Units Per Carton": item.unitsPerCarton,
        "Retail Price": Number(item.retailPrice || 0).toFixed(2),
        "Quantity Price": Number(item.quantityPrice || 0).toFixed(2),
        "Wholesale Price": Number(item.wholesalePrice || 0).toFixed(2),
        "Warehouse": item.warehouse,
        "In Stock": Number(item.inStock || 0).toFixed(0),
        "Committed": Number(item.committed || 0).toFixed(0),
        "Available": Number(item.available || 0).toFixed(0),
        "Arrival Qty": Number(item.arrivalQuantity || 0).toFixed(0),
        "ETA": item.eta || ""
      }));

      // Create xlsx worksheet and workbook
      const worksheet = XLSX.utils.json_to_sheet(filterData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Item Search");
      XLSX.writeFile(workbook, "ItemSearchReport.xlsx", { compression: true });
    } catch (error) {
      console.error("Failed to export Excel report:", error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      {/* Title */}
      <PageTitle title={"Item Search"}/>
      
      {/* Link and Export Button Bar */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div style={{ display: "flex" }}>
          <DashboardLink />
          <CurrentPage currentPage={"Item Search"} />
        </div>
        
        {/* Export to Excel Button */}
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleExport}
          disabled={isExporting}
        >
          {isExporting ? "Exporting..." : "Export to Excel"}
        </Button>
      </div>

      <PagedSortableTable
        baseUrl={"/itemsearch"}
        columns={itemSearchColumns}
        title="Item Search"
        BodyComponent={ItemSearchList}
        DialogComponent={ItemSearchDialog}
        defaultFilter={user.warehouse ? `warehouse=${user.warehouse}` : ""}
      />
    </>
  );
}